// Clients shown in "Brands That Trust Parcelin". Logos go in src/assets/clients/.
const trustedClients = [
  {
    name: "Khanyisa A Wellness",
    logo: require("../assets/clients/kaw.jpg"),
    link: "https://www.khanyisaawellness.co.za/",
  },
  {
    name: "Tshovelo Business Solutions",
    logo: require("../assets/clients/tbs.jpg"),
    link: "https://www.tshovelo.co.za/",
  },
  {
    name: "Mahera Beauty",
    logo: require("../assets/clients/mahera.jpg"),
    link: "https://web.facebook.com/MAHERABEAUTY",
  },
{
    name: "Lass Skincare",
    logo: require("../assets/clients/lass.png"),
    link: "https://www.lassskincare.co.za/",
  },
  {
    name: "Guru Nation",
    logo: require("../assets/clients/guru-nation.webp"),
    link: "https://guru-nation.lovable.app/",
  },
];

export default trustedClients;
